<template id="copy-modal-template">
  <base-form :do="save" :v-errors="error" class="flex flex-col" id="copy-modal">
    <div class="modal-body content">
      <div class="group fields">
        <div class="field-group">
          <div class="field-heading">
            <label>Aantal kopieën&nbsp;</label>
          </div>
          <input
            class="text"
            type="number"
            name="amount"
            min="1"
            max="20"
            v-model.number="amount"
            v-validate="'required|integer|between:1,20'"
            data-vv-as="Aantal kopieën"
          />
          <transition name="slide">
            <span
              v-if="errors.first('amount')"
              class="block form-error text-xs"
            >
              {{ errors.first('amount') }}
            </span>
          </transition>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-tertiary btn-sm" @click="close">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary btn-sm">Kopiëren</button>
    </div>
  </base-form>
</template>

<script>
import SubjectService from '@/services/subject';
import BaseForm from '@/components/globals/BaseForm';

import { EventBus } from '@/event-bus';
import { mapMutations } from 'vuex';
import { HIDE_MODAL } from '@/store/mutations.types';

export default {
  name: 'CopyModal',
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    BaseForm,
  },
  data() {
    return {
      subjectId: null,
      amount: 1,
      error: null,
    };
  },
  created() {
    this.subjectId = this.$store.state.modal.items.subjectId;
  },
  methods: {
    ...mapMutations('modal', {
      hide: HIDE_MODAL,
    }),
    close() {
      this.$validator.reset();
      this.hide();
    },
    async save() {
      try {
        await SubjectService.copy(this.subjectId, this.amount);
        EventBus.$emit('subject-copied');
        this.close();
      } catch (error) {
        if (error.data && error.data.details && error.data.details.amount) {
          this.error = error.data;
          return;
        }
        EventBus.$emit('subject-copy-failed');
        this.close();
      }
    },
  },
};
</script>
